// Simple SSA-brand wordmark. Swap the ball for the SSA crest webp when available.
export function Logo({ className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 font-extrabold tracking-tight ${className}`}>
      <span className="text-2xl leading-none">⚽</span>
      <span className="text-brand-700">
        Gear<span className="text-brand-500">Exchange</span>
      </span>
    </span>
  );
}
